/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect } from 'react';
// @mui
import {
  Stack, Typography, Box, Container, Grid, Card, CardHeader, IconButton,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import MultiSelector from '../components/multi-selector/multiSelector';
import VideoPlayer from '../components/video-player/videoPlayer';
import axiosInstance from '../utils/axiosInstance';

export default function SensorRecordedStream() {
  const sensorList = useSelector((state) => state.app.sensorList);
  const [selectedSensorList, setSelectedSensorList] = useState([]);
  const [sensorWithTimelines, setSensorWithTimelines] = useState([]);
  const [sensorInRow, setSensorInRow] = useState(1);
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();

  useEffect(() => {
    window.recordedStreamingSensors = selectedSensorList;
    return () => {
      window.recordedStreamingSensors = null;
    };
  }, [selectedSensorList]);

  const checkTimelines = async (sensor) => {
    console.log("Checking timelines for sensor:", sensor.name);

    try {
      const response = await axiosInstance.get(
        `${window.location.protocol}//${sensor.host}/api/v1/record/${sensor.sensorId}/timelines`,{ headers: { "streamId": sensor.sensorId } }
      );

      const isTimelinePresent = response.data && response.data.length > 0;
      console.log(`${sensor.name} Timelines:`, isTimelinePresent ? "present" : "not present");

      return isTimelinePresent;
    } catch (error) {
      console.log("Failed to fetch timelines for sensor:", sensor.name);
      return false;
    }
  };

  useEffect(() => {
    if (location.pathname !== '/vst/recorded-streams' && location.pathname !== '/mms/recorded-streams') {
      return;
    }
    const filterCamsWithTimelines = async () => {
      const camsWithTimelines = [];
      for (const sensor of sensorList) {
        const f = await checkTimelines(sensor);
        if (f) {
          camsWithTimelines.push(sensor);
        }
      }

      console.log("cams with timelines", camsWithTimelines)

      setSensorWithTimelines(camsWithTimelines);
    };
    filterCamsWithTimelines();
  }, [location, sensorList]);

  const handleInputValue = (val) => {
    setInputValue(val);
  };
  const handleSelectedSensorListChange = (val) => {
    setSelectedSensorList(val);
  };

  const handleZoomOut = () => {
    setSensorInRow((prev) => (prev < 3 ? prev + 1 : prev));
  };

  const handleZoomIn = () => {
    setSensorInRow((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const closeSensor = (sensor) => {
    const temp = selectedSensorList.filter((item) => item.sensorId !== sensor.sensorId);
    setSelectedSensorList(temp);
  };

  // Filter out selected sensors from the sensorList
  const availableSensors = sensorWithTimelines.filter(
    (sensor) => !selectedSensorList.some(selectedSensor => selectedSensor.sensorId === sensor.sensorId)
  );

  return (
    <div
      style={{
        display:
          location.pathname === '/vst/recorded-streams' || location.pathname === '/mms/recorded-streams'
            ? 'inline'
            : 'none',
      }}
    >
      <Helmet>
        <title> stream </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Recorded streams
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader title="Recorded streams" subheader="Stream recorded streams" />
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="recorded-stream-selector-multi"
                    placeholder="Type to search"
                    label="Select sensors"
                    value={selectedSensorList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedSensorListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={availableSensors}
                  />
                </Stack>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{
                    display: {
                      xs: 'none', sm: 'none', md: 'none', lg: 'flex',
                    },
                  }}
                >
                  <IconButton id="zoom-in" onClick={handleZoomIn}>
                    <ZoomInIcon />
                  </IconButton>
                  <IconButton id="zoom-out" onClick={handleZoomOut}>
                    <ZoomOutIcon />
                  </IconButton>
                </Box>
              </Box>
            </Card>
          </Grid>
          {selectedSensorList.map((sensor) => (
            <Grid item xs={12} sm={12} md={12 / sensorInRow} key={sensor.sensorId}>
              <VideoPlayer sensor={sensor} sensorInRow={sensorInRow} page="recorded" closeSensor={closeSensor} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
